import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import {post,fetch,put} from './utils/request'
import "@/style/public.css"

Vue.config.productionTip = false
// Vue.prototype.baseUrl = "http://10.0.20.42:9080"
Vue.prototype.$post = post
Vue.prototype.$fetch = fetch
Vue.prototype.$put = put

let time = null
Vue.prototype.$tip = function(value){
    let dom = document.getElementById("tipBox")
    if(dom){
        dom.remove()
        if(time){
            clearTimeout(time)
        }
    }
    let tipBox = document.createElement("div")
    tipBox.id = "tipBox"
    tipBox.classList = "tip-box"
    tipBox.innerText = value
    document.body.appendChild(tipBox)
    time = setTimeout(() => {
        document.getElementById("tipBox").remove()
    }, 3000);
}
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
